<script>
import axios from "axios";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ModalProgress from "./modal-progress.vue";
import Swal from "sweetalert2";
import _ from "lodash";
import TabProgressBatch from './progress-batch/tab-progress-batch.vue';

export default {
  page: {
    title: "Penjadwalan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Datatable, Pagination, Layout, ModalProgress, PageHeader,
    TabProgressBatch,
  },

  watch: {
    idJadwal: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getPeserta();
      }
    },
  },
  data() {
    return {
      idJadwal: this.$route.params.idjadwal,
      isLoading: false,
      column: [
        { width: "150px", label: "Batch", name: "-" },
        { width: "auto", label: "NIP", name: "-" },
        { width: "auto", label: "Nama", name: "-" },
        { width: "50%", label: "Kompetensi", name: "-" },
        { width: "200px", label: "Status", name: "-" },
      ],
      pagination: {},
      tableFilter: {
        page: 1, per_page: 10, nip: "", nama: "",
        nama_batch: "", kompetensi: "", status: "",
      },
      tableData: [],
      optionFilterBatch: [],
      optionFilterKompetensi: [],
      optionFilterStatus: [
        { value: 1, label: "Belum Mengerjakan" },
        { value: 2, label: "Sedang Mengerjakan" },
        { value: 3, label: "Sudah Mengerjakan" },
      ],
      showModalProgress: false,
      selected_idjadwal: "",
      selected_idkompetensi: "",
      selected_idlevel: "",
      selected_idpeserta: "",
    };
  },
  mounted() {
    this.getPeserta();
    this.getFilterBatch();
    this.getFilterKompetensi();
    this.filterBatch = _.debounce(this.searchBatch.bind(this), 500);
    this.filterKompetensi = _.debounce(this.searchKomptensi.bind(this), 500);
    this.filterData = _.debounce(this.getPeserta.bind(this), 500);
  },
  methods: {
    async getFilterBatch(search = "", loading) {
      await axios({
        method: "get",
        url:
          `${process.env.VUE_APP_BACKEND_URL_VERSION}referensi/jadwal-batch/all`,
        params: { search: search, limit: 10 },
        headers: { Authorization: "Bearer " + localStorage.access_token },
      }).then((response) => {
        this.optionFilterBatch = response.data.data;
        if (loading) loading(false);
      });
    },
    async searchBatch(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterBatch(search, loading);
      }
    },
    async getFilterKompetensi(search = "", loading) {
      await axios({
        method: "get",
        url:
          `${process.env.VUE_APP_BACKEND_URL_VERSION}referensi/kompetensi/all`,
        params: { search: search, limit: 10 },
        headers: { Authorization: "Bearer " + localStorage.access_token },
      }).then((response) => {
        this.optionFilterKompetensi = response.data.data;
        if (loading) loading(false);
      });
    },
    async searchKomptensi(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterKompetensi(search, loading);
      }
    },
    async getPeserta() {
      this.isLoading = true;
      const data = await axios({
        method: "get",
        url:
          `${process.env.VUE_APP_BACKEND_URL_VERSION}master/jadwal-pelaksanaan/${this.idJadwal}/monitor`,
        params: this.tableFilter,
        headers: { Authorization: "Bearer " + localStorage.access_token },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.tableData = data.data;
        this.pagination = data;
      }
      this.isLoading = false;
    },
    toPage(url) {
        if(url){
            let link = new URLSearchParams(url.split('?')[1]);
            this.tableFilter.page = link.get("page");
            this.getPeserta();
        }
    },
    listKompetensi(row) {
      if (row.kompetensi_with_status && row.kompetensi_with_status.includes(",")) {
        return row.kompetensi_with_status?.split(",");
      }
      let listKomp = [];
      listKomp.push(row.kompetensi_with_status);
      return listKomp;
    },
    getKompetensi(val, index = 0) {
      let kompetensi = val?.split("|");
      return kompetensi[index];
    },
    getLabelKompetensi(val) {
      let kompetensi = val?.split("|")[0];
      let status = kompetensi.split(" - ")[1];
      let kompetensiName = kompetensi.split(" - ")[0];
      let badgeClass = "bg-secondary";
      if (status === "Belum Mengerjakan") badgeClass = "bg-danger";
      else if (status === "Sedang Mengerjakan") badgeClass = "bg-warning";
      else if (status === "Sudah Mengerjakan") badgeClass = "bg-success";
      return `${kompetensiName} <span class="badge ${badgeClass}">${status}</span>`;
    },
    getStatusKompetensi(val) {
      let kompetensi = val?.split("|")[0];
      return kompetensi.split(" - ")[1];
    },
    getLevelKompetensi(val) {
      let kompetensi = val?.split("|")[0];
      let kompetensiName = kompetensi.split(" - ")[0];
      return kompetensiName.split("-")[1];
    },
    statusMonitor(row) {
        let status = "Belum Mengerjakan";
        if (row.kompetensi_with_status) {
            const listKompetensi = this.listKompetensi(row);
            if (listKompetensi && Array.isArray(listKompetensi)) {
                const statuses = listKompetensi.map(e => e.split(" - ")[1].split("|")[0]);
                if (statuses.includes("Sedang Mengerjakan")) {
                    status = "Sedang Mengerjakan";
                } else if (statuses.every(s => s === "Sudah Mengerjakan")) {
                    status = "Sudah Mengerjakan";
                }
            }
        }
        let badgeClass = "bg-secondary";
        if (status === "Belum Mengerjakan") badgeClass = "bg-danger";
        else if (status === "Sedang Mengerjakan") badgeClass = "bg-warning";
        else if (status === "Sudah Mengerjakan") badgeClass = "bg-success";
        return `<span class="badge ${badgeClass}">${status}</span>`;
    },
    setShowModalProgress(idjadwal, idjadwal_peserta, id_kompetensi, level) {
      this.showModalProgress = !this.showModalProgress;
      this.selected_idjadwal = idjadwal;
      this.selected_idkompetensi = id_kompetensi;
      this.selected_idlevel = level;
      this.selected_idpeserta = idjadwal_peserta;
    },
    async updateStatusJadwal(idjadwal, idjadwal_peserta, id_kompetensi, level, idJadwalBatch, status) {
        const result = await Swal.fire({
            title: "Konfirmasi", text: "Apakah Anda yakin ingin menghentikan jadwal?",
            icon: "warning", showCancelButton: true, confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33", confirmButtonText: "Ya, perbarui", cancelButtonText: "Batal",
        });

        if (result.isConfirmed) {
            this.isLoading = true;
            try {
                await axios({
                    method: "put",
                    url: `${process.env.VUE_APP_BACKEND_URL_VERSION}master/jadwal-pelaksanaan/monitor/${idjadwal}`,
                    data: {
                        level_idlevel: level, status: status,
                        jadwal_peserta_idjadwal_peserta: idjadwal_peserta,
                        jadwal_idjadwal: idjadwal,
                        jadwal_batch_idjadwal_batch: idJadwalBatch,
                        kompetensi_idkompetensi: id_kompetensi,
                    },
                    headers: { Authorization: "Bearer " + localStorage.access_token },
                });
                Swal.fire("Berhasil", "Status jadwal pelaksanaan berhasil diperbarui.", "success");
                this.getPeserta();
            } catch (error) {
                Swal.fire("Gagal", "Terjadi kesalahan saat memperbarui status.", "error");
            } finally {
                this.isLoading = false;
            }
        }
    },
    exportExcel() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(`${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/jadwal-pelaksanaan/${this.idJadwal}/monitor?${params}`);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-2">
      <div class="col-12">
        <router-link
          class="btn btn-danger btn-sm"
          :to="{ name: 'all-jadwal-pelaksanaan' }"
          >Kembali</router-link
        >
      </div>
    </div>

    <b-card no-body>
      <b-tabs pills card>
        
        <b-tab title="Monitoring Jadwal Pelaksanaan" active>
          <b-card-text>
            <div class="row">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <div class="card-title">Monitoring Jadwal Pelaksanaan</div>
                    </div>
                    <div class="col-6 text-end">
                      <button class="btn btn-success btn-sm" @click="exportExcel()">
                        <i class="fa fa-file-excel me-1"></i> Export Excel
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <hr />
                    <div class="form-group col-md-4 mb-2">
                      <label for="filterBatch">Batch</label>
                      <v-select
                        id="filter_batch"
                        class="style-chooser"
                        :options="optionFilterBatch"
                        :reduce="(batch) => batch.nama_batch"
                        :deselectFromDropdown="true"
                        label="nama_batch"
                        v-model="tableFilter.nama_batch"
                        placeholder="Filter Batch"
                        @search="filterBatch"
                        @clear="getPeserta"
                        v-on:update:model-value="getPeserta"
                      />
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="filterNIP">NIP</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Filter NIP"
                        v-model="tableFilter.nip"
                        @input="filterData"
                      />
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="filterNama">Nama</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Filter Nama"
                        v-model="tableFilter.nama"
                        @input="filterData"
                      />
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="filterKompetensi">Kompetensi</label>
                      <v-select
                        id="filter_kompetensi"
                        class="style-chooser"
                        :options="optionFilterKompetensi"
                        :reduce="(kompetensi) => kompetensi.nama_kompetensi"
                        :deselectFromDropdown="true"
                        label="nama_kompetensi"
                        v-model="tableFilter.kompetensi"
                        placeholder="Filter Kompetensi"
                        @search="filterKompetensi"
                        @clear="getPeserta"
                        v-on:update:model-value="getPeserta"
                      />
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="filterStatus">Status</label>
                      <v-select
                        id="filter_status"
                        class="style-chooser"
                        :options="optionFilterStatus"
                        :reduce="(status) => status.value"
                        :deselectFromDropdown="true"
                        label="label"
                        v-model="tableFilter.status"
                        placeholder="Filter Status"
                        @clear="getPeserta"
                        v-on:update:model-value="getPeserta"
                      />
                    </div>
                    <hr />
                  </div>
                  <table class="mb-2">
                    <tr>
                      <td>Show</td>
                      <td>
                        <select
                          class="form-control form-control-sm"
                          id="showpaginatetable"
                          v-model="tableFilter.per_page"
                          @change="getPeserta()"
                        >
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="500">500</option>
                        </select>
                      </td>
                      <td>Entries</td>
                    </tr>
                  </table>
                  <Datatable :columns="column">
                    <tbody>
                      <tr v-if="isLoading">
                        <td colspan="99" class="text-center">
                          <i class="fa fa-spinner fa-spin"></i> Loading...
                        </td>
                      </tr>
                      <tr v-else-if="!tableData.length">
                        <td colspan="99" class="text-center">
                          <i class="fa fa-exclamation-triangle"></i>
                          Data tidak ditemukan
                        </td>
                      </tr>
                      <tr
                        v-else
                        v-for="row in tableData"
                        :key="row.jadwal_peserta_idjadwal_peserta"
                      >
                        <td>{{ row.nama_batch }}</td>
                        <td>{{ row.nip }}</td>
                        <td>{{ row.nama }}</td>
                        <td style="padding: 0">
                          <table
                            class="table table-sm m-0"
                            v-if="row.kompetensi_with_status"
                          >
                            <tr
                              v-for="(komp, index) in listKompetensi(row)"
                              :key="index"
                            >
                              <td v-html="getLabelKompetensi(komp)"></td>
                              <td class="text-center" style="width: 125px">
                                <button
                                  v-if="getStatusKompetensi(komp) === 'Sedang Mengerjakan'"
                                  class="btn btn-sm btn-outline-secondary"
                                  @click="updateStatusJadwal(idJadwal, row.jadwal_peserta_idjadwal_peserta, getKompetensi(komp, 1), getLevelKompetensi(komp), row.jadwal_batch_idjadwal_batch, 4)"
                                >
                                  <i class="fa fa-ban"></i> Hentikan
                                </button>
                              </td>
                              <td class="text-center" style="width: 125px">
                                <button
                                  class="btn btn-sm btn-outline-success"
                                  @click="setShowModalProgress(idJadwal, row.jadwal_peserta_idjadwal_peserta, getKompetensi(komp, 1), getLevelKompetensi(komp))"
                                >
                                  <i class="fa fa-eye"></i> Lihat Progress
                                </button>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td v-html="statusMonitor(row)"></td>
                      </tr>
                    </tbody>
                  </Datatable>
                  <pagination :pagination="pagination" @to-page="toPage"></pagination>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab title="Progress Peserta">
          <b-card-text>
            <TabProgressBatch :id-jadwal="idJadwal" />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-modal
      v-model="showModalProgress"
      hide-footer
      title="Progress Asesmen"
      size="xl"
      scrollable
    >
      <ModalProgress
        v-if="showModalProgress"
        :idjadwal="selected_idjadwal"
        :id_kompetensi="selected_idkompetensi"
        :idjadwal_peserta="selected_idpeserta"
        :level="selected_idlevel"
      />
    </b-modal>
  </Layout>
</template>

<style scoped></style>